import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "submitBtn",
    "ratingInput",
    "positiveSection",
    "improvementsSection",
    "positiveComment",
    "improvementsComment"
  ]

  connect() {
    this.showModal()
  }

  showModal() {
    $(this.element).modal({ backdrop: 'static', keyboard: false }).modal('show')
  }

  hideModal() {
    $(this.element).modal('hide')
  }

  ratingChanged() {
    const rating = this.selectedRating()
    this.positiveSectionTarget.classList.toggle('d-none', rating === null || rating < 4)
    // Always show improvements section once a rating is selected (including >= 4)
    this.improvementsSectionTarget.classList.toggle('d-none', rating === null)
    if (rating === null) {
      this.positiveCommentTarget.value = ''
      this.improvementsCommentTarget.value = ''
    }
    this.updateSubmitState()
  }

  commentChanged() {
    this.updateSubmitState()
  }

  submit() {
    if (!this.canSubmit()) return

    const rating = this.selectedRating()
    const payload = {
      no_opinion: false,
      rating: rating,
      positive_comment: rating >= 4 ? this.positiveCommentTarget.value.trim() : '',
      improvements_comment: this.improvementsCommentTarget.value.trim()
    }
    this.submitResponse(payload)
  }

  submitNoOpinion() {
    this.submitResponse({ no_opinion: true })
  }

  submitResponse(payload) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch('/reviews', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        if (response.ok) {
          this.hideModal()
        }
      })
      .catch(error => {
        console.error('Review submission error:', error)
      })
  }

  selectedRating() {
    const checked = this.formTarget.querySelector('input[name="rating"]:checked')
    return checked ? parseInt(checked.value, 10) : null
  }

  canSubmit() {
    return this.selectedRating() !== null
  }

  updateSubmitState() {
    this.submitBtnTarget.disabled = !this.canSubmit()
  }
}
